<template lang="html">
	<div id="pin-chart" class="canvas-parent">
		<!-- {{data}} -->
		<canvas></canvas>
	</div>
</template>

<script>
const Chart = require('chart.js');

module.exports = {
	props: ['data'],

	data() {
		return {
			activated: false
		}
	},

	// watch: {
	// 	data() {
	// 		if(!this.activated) {
	// 			let ctx = this.$el.querySelector("canvas");
	//
	// 			let myChart = new Chart(ctx, {
	// 				type: 'line',
	//
	// 				data: this.data,
	//
	// 				options: {
	// 					maintainAspectRatio: false,
	// 					scales: {
	// 						yAxes: [{
	// 							ticks: {
	// 								beginAtZero:true
	// 							}
	// 						}]
	// 					}
	// 				}
	// 			});
	//
	// 			this.activated = true;
	// 		}
	// 	}
	// },

	mounted() {
		let controller = new ScrollMagic.Controller();

		var scene = new ScrollMagic.Scene({
			triggerElement: '#pin-chart',
			duration: 0,
			triggerHook: .6
		});

		// scene.setPin("#pin-chart");
		scene.setClassToggle("#pin-chart", "active");
		// scene.addIndicators();
		scene.addTo(controller);

		scene.on('start', () => {
			// console.log(this.data);
			if(!this.activated && this.data.datasets) {
				let ctx = this.$el.querySelector("canvas");

				let myChart = new Chart(ctx, {
					type: 'line',

					data: this.data,


					options: {
						maintainAspectRatio: false,
	
						scales: {
							yAxes: [{
								display: false,
								ticks: {
									beginAtZero: true
								}
							}],
							xAxes: [{
								ticks: {
									beginAtZero: true
								}
							}]
						}
					}
				});

				this.activated = true;
			}
		})
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.Chart.project {

		.canvas-parent {
			position: static !important;
			width: 100%;
			height: 150px;
			@include m_up {
				height: 220px;
			};
			@include m___up {
				height: 250px;
			};
		}
	}
</style>



// WEBPACK FOOTER //
// project.vue?37d59be3